import { Component, OnInit } from '@angular/core';
import { PrimeNGConfig, TreeNode } from 'primeng/api';
import { Router } from '@angular/router';
import { UserService } from './core';

import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {

    topbarColor = 'layout-topbar-materialone';

    menuColor = 'layout-menu-materialone';

    themeColor = 'yellow';

    layoutColor = 'amber';

    topbarSize = 'large';

    horizontal = true;

    inputStyle = 'filled';

    ripple = true;

    compactMode = false;

    constructor(
        private primengConfig: PrimeNGConfig,
        private translateService: TranslateService,
        private router: Router,
        public userService: UserService
    ) { }

    isAuthenticated: boolean;
    ngOnInit() {
        this.userService.populate();
        this.primengConfig.ripple = true;
        this.translateService.setDefaultLang('es_EC');
    }

    translate(lang: string) {
        this.translateService.use(lang);
        this.translateService.get('primeng').subscribe(res => this.primengConfig.setTranslation(res));
    }
    
}
